<template>
	<v-container>
		<v-card flat>
			<v-card-title class="text-h4">Звіти</v-card-title>
			<v-card-text>
				<v-row v-for="(type, c) in items" :key="c">
					<!-- <v-col cols="12" :md="items.length < 3 ? 0 : 6" v-for="(item, index) in items" :key="index"> -->
					<v-col cols="12" md="4" v-for="(report, r) in type.reports" :key="r">
						<v-hover v-slot:default="{ hover }">
							<v-card 
								:elevation="hover ? 3 : 1"
								:class="{ 'on-hover': hover }"
								class="mx-auto"
								outlined
								:to="{ name: report.to }"
								
							>
								<v-list-item three-line>
									<!-- <v-list-item-content>
										<div class="text-overline mb-4">
											{{ type.name }}
										</div>
										<v-list-item-title class="">
											{{ report.name }}
										</v-list-item-title>
										<v-list-item-subtitle>{{ report.description }}</v-list-item-subtitle>
									</v-list-item-content> -->

									<v-list-item-avatar>
										 <v-icon :color="report.color">{{ report.icon }}</v-icon>
									</v-list-item-avatar>
									<v-list-item-content>
										<v-list-item-title v-html="report.name" class="font-weight-bold"></v-list-item-title>
										<v-list-item-subtitle v-html="report.description"></v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-card>
												
						</v-hover>
					</v-col>
				</v-row>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-text>
				<v-row>
					<v-col cols="12" md="4" v-for="(file, index) in files" :key="index">
						<v-hover v-slot:default="{ hover }">
							<!-- <v-card 
								:elevation="hover ? 3 : 1"
								:class="{ 'on-hover': hover }"
								class="mx-auto"
								outlined
								:href="file.href"
							>
								<v-list-item three-line>
									<v-list-item-avatar>
										 <v-icon :color="file.color" large>{{ file.icon }}</v-icon>
									</v-list-item-avatar>
									<v-list-item-content>
										<v-list-item-title v-html="file.name" class="font-weight-bold"></v-list-item-title>
										<v-list-item-subtitle v-html="file.description"></v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-card> -->
							<v-card 
								:elevation="hover ? 3 : 1"
								:class="{ 'on-hover': hover }"
								class="mx-auto"
								outlined
								:href="file.href"
							>
								<!-- <v-card-title class="text-subtitle-1 font-weight-bold">{{ file.title }}</v-card-title> -->
								<v-card-title class="text-subtitle-1 font-weight-bold">
									
									<v-icon large left :color="file.color">{{ file.icon }}</v-icon>
									<span class="text-subtitle-1 font-weight-bold">{{ file.title }}</span>
								</v-card-title>
								<v-card-subtitle>{{ file.subtitle }}</v-card-subtitle>
								<v-card-text>
									{{ file.text }}
								</v-card-text>

								<!-- <v-list-item three-line>
									<v-list-item-avatar>
										 <v-icon :color="file.color" large>{{ file.icon }}</v-icon>
									</v-list-item-avatar>
									<v-list-item-content>
										<v-list-item-title v-html="file.name" class="font-weight-bold"></v-list-item-title>
										<v-list-item-subtitle v-html="file.description"></v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item> -->
							</v-card>
												
						</v-hover>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
	</v-container>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
	name: 'Tariff',
	data: () => ({
		loading: false,
		items: [
			{ code: 'VehicleRequest', name: 'Запити', description: ''
				,reports: [
					{ code: 'VehicleRequestCount', name: 'Всього запитів', description: 'Визначення кількості запитів за період', to: 'ReportVehicleRequestCount', icon: 'mdi-file-chart', color: 'red darken-1' },
					{ code: 'VehicleRequestTypeCount', name: 'По типам', description: 'Визначення кількості запитів за період з розбиттям по типам ', to: 'ReportVehicleRequestTypeCount', icon: 'mdi-file-chart', color: 'red darken-2' },
					{ code: 'VehicleRequestTypeUserOrganisationCount', name: 'По типам і користувачам', description: 'Визначення кількості запитів за період з розбиттям по типам запитів і користувачам', to: 'ReportVehicleRequestTypeUserOrganisationCount', icon: 'mdi-file-chart', color: 'red darken-3' },
					{ code: 'VehicleRequestBrandModelCount', name: 'Маркам та моделям', description: 'Визначення кількості запитів за період з розбиттям по  маркам та моделям', to: 'ReportVehicleRequestBrandModelCount', icon: 'mdi-file-chart', color: 'red darken-4' },
					{ code: 'VehicleRequestOrganisationCount', name: 'По організаціям', description: 'Визначення кількості запитів за період з розбиттям по організаціям', to: 'ReportVehicleRequestOrganisationCount', icon: 'mdi-file-chart', color: 'red lighten-1' },
					{ code: 'VehicleRequestOrganisationMonthly', name: 'По організації', description: 'Статистика запитів організації помісячно', to: 'ReportVehicleRequestOrganisationMonthly', icon: 'mdi-file-chart', color: 'red lighten-1' },
					{ code: 'VehicleRequestOrganisationTypeCount', name: 'По організаціям та типам', description: 'Визначення загальної кількості запитів та запитів без результату за період з розбиттям по організаціям та типам запитів', to: 'ReportVehicleRequestOrganisationTypeCount', icon: 'mdi-file-chart', color: 'red lighten-2' },
					{ code: 'VehicleRequestList', name: 'Запити', description: 'Перелік запитів за період в залежності від організації та опцій', to: 'ReportVehicleRequestList', icon: 'mdi-file-chart', color: 'red lighten-3' },
					{ code: 'VehicleRequestDetail', name: 'Запит', description: 'Деталі запиту', to: 'ReportVehicleRequestDetail', icon: 'mdi-file-chart', color: 'red lighten-4' },
					{ code: 'VehicleRequestBrandYearAvgPrice', name: 'Середня ціна легкових авто за маркою', description: 'Статистика середньої ціни легкових автомобілів в розрізі марки та року виробництва', to: 'ReportVehicleRequestBrandYearAvgPrice', icon: 'mdi-file-chart', color: 'red accent-1' },
				]
			},
			{ code: 'VehicleRequest', name: 'Ідентифікація транспортних засобів', description: ''
				,reports: [
					{ code: 'VehicleRequestIdentification', name: 'Статистика по ідентифікації', description: 'Статистика по запитам щодо ідентифікації транспортних засобів', to: 'ReportVehicleRequestIdentification', icon: 'mdi-file-chart', color: 'black' },
				]
			},
			{ code: 'VehicleRequest', name: 'Ідентифікація транспортних засобів', description: ''
				,reports: [
					{ code: 'VehicleVinDecoding', name: 'Ідентифікація за VIN-кодом', description: 'Ідентифікація транспортного засобу за VIN-кодом', to: 'ReportVehicleVinDecoding', icon: 'mdi-code-brackets', color: 'blue' },
				]
			},
			{ code: 'VehicleEstimate', name: 'Оцінка транспортних засобів', description: ''
				,reports: [
					{ code: 'VehicleMarketValue', name: 'Ринкова вартість ТЗ', description: 'Визначення ринкової вартісті ТЗ за параметрами: марка, модель, тип ТЗ, рік виробництва', to: 'ReportVehicleMarketValue', icon: 'mdi-cash-100', color: 'light-green' },
				]
			},
		],

		select: [],

		calculate: {
			services: [],
			requestCount: null,
			userCount: null,
			price: null,
		},

		files: []
	}),
	
	computed: {
		...mapGetters([ 'holder', 'authorized', 'profile', 'services' ]),
		/* to() {
			//console.log(this.router)

			return {name: this.router}
		} */
		/* image() {
			if(this.item.image) {
				//return process.env.VUE_APP_URL + process.env.VUE_APP_PROFILES_UPLOADS+'/'+this.item.image;
				return this.item.image
			} else {
				return require('../assets/drug.png')
			}
		}, */
	},
	watch: {
		
	},
	created() {
		//console.log(this.$options.name, 'created')
		this.getFiles()
	},
	methods: {
		getFiles() {
			//if(this.organizations.length == 0) {
				var that = this
				this.loading = true;
				axios.get('/report/files').then(response => {
					//console.log(that.$options.name, 'getFiles','response.data', response.data)
					
					that.files = response.data
				}, error => {
					console.log('error', error)
				}).finally(() => {
					this.loading = false
				});
			//}
		},
	},
}
</script>